/**
 * Custom error class for errors originating from Context Providers.
 */
class ProviderError extends Error {
    /**
     * Creates an instance of ProviderError.
     * @param {string} message - The error message.
     * @param {string} [providerName='UnknownProvider'] - The name of the provider where the error occurred.
     * @param {object} [details={}] - Additional details or context about the error.
     */
    constructor(message, providerName = 'UnknownProvider', details = {}) {
        // Pass remaining arguments (including vendor specific ones) to parent constructor
        super(message);

        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ProviderError);
        }

        // Custom debugging information
        this.name = 'ProviderError';
        this.providerName = providerName;
        this.details = details;
        this.date = new Date();
    }
}

export default ProviderError;
